export const organisationUrl = domain => `${domain}monitoring/organisation/`;

export const isOrganisationResponse = data =>
  data != null && typeof data.organisation_id === "string" && typeof data.organisation_name === "string";

export const organisationFromApi = data => ({
  organisationId: data.organisation_id,
  organisationName: data.organisation_name,
});

export const organisationToApi = form => ({
  organisation_id: form.organisationId.trim(),
  organisation_name: form.organisationName.trim(),
});
